import VueRouter from 'vue-router'

const routes = [
  { path: '/', name: 'home', component: () => import('./views/Home.vue') },
  { path: '/jobs', name: 'jobs', component: () => import('./views/Jobs.vue') },
  { path: '/jobs/:id', name: 'jobDetail', component: () => import('./views/JobDetail.vue') },
  { path: '/talents', name: 'talents', component: () => import('./views/Talents.vue') },
  { path: '/policies', name: 'policies', component: () => import('./views/Policies.vue') },
  { path: '/tools', name: 'tools', component: () => import('./views/Tools.vue') },
  { path: '/user', name: 'user', component: () => import('./views/User.vue') },
  { path: '/register', name: 'register', component: () => import('./views/Register.vue') },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
